import { render, staticRenderFns } from "./good-tag.vue?vue&type=template&id=72b27cab&scoped=true"
import script from "./good-tag.vue?vue&type=script&lang=js"
export * from "./good-tag.vue?vue&type=script&lang=js"
import style0 from "./good-tag.vue?vue&type=style&index=0&id=72b27cab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b27cab",
  null
  
)

export default component.exports